/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  deleteCartItemSuccess,
  deleteCartItemFailure,
  DeleteCartItemAction,
  DeleteCartItemActionTypes,
} from '../actions/DeleteCartItem';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';
import deleteCartItemService from '../services/DeleteCartItem';

const DeleteCartItemEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(DeleteCartItemActionTypes.DELETE_CART_ITEM)),
  mergeMap((action: DeleteCartItemAction) => from(
    deleteCartItemService(
      action.payload.cartAliasId,
      action.payload.cartItemAliasId,
    ),
  ).pipe(
    map((response) => deleteCartItemSuccess()),
    catchError((error: IErrorActionData) => of(
      deleteCartItemFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default DeleteCartItemEpic;
